import {Product} from "../Product/Product";
import {addDays, startOfMonth, addMonths} from "date-fns";

export type ScheduledShipment = {
    id: number
    isAdmin: boolean
    product: Product
    dealershipId: number
    quantity: number
    reorderPeriod: number
    nextStartDate: string
    createdAt: number
    updatedAt: number
}

export type ScheduledShipmentSimple = {
    id: number
    isAdmin: boolean
    dealershipId: number
    quantity: number
    reorderPeriod: number
    nextStartDate: string
}

export type ScheduledShipmentFilterRequest = {
    productId?: number
    dealershipId?: number
    reorder?: number
    quantity?: number
    startDate?: number
}

export enum ReorderPeriod {
    ONE_MONTH = 30,
    TWO_MONTHS = 60,
    THREE_MONTHS = 90,
    SIX_MONTHS = 180,
    ONE_YEAR = 360
}

export type OptionValue = { label: string; value: number | string | boolean };
export const optionReorderValues: OptionValue[] = [
    {label: 'no selected', value: 0},
    {label: '1 month', value: 30},
    {label: '2 months', value: 60},
    {label: '3 months', value: 90},
    {label: '4 months', value: 120},
    {label: '5 months', value: 150},
    {label: '6 months', value: 180},
    {label: '7 months', value: 210},
    {label: '8 months', value: 240},
    {label: '9 months', value: 270},
    {label: '10 months', value: 300},
    {label: '11 months', value: 330},
    {label: '1 year', value: 360}
];

export const optionReorderWeeklyValues: OptionValue[] = [
    {label: 'no selected', value: 0},
    {label: '1 week', value: 7},
    {label: '2 weeks', value: 14},
    {label: '3 weeks', value: 21},
    {label: '4 weeks', value: 28},
    {label: '5 weeks', value: 35},
    {label: '6 weeks', value: 42}
];

export interface ReqSSConfig {
    params?: {
        page: number;
        size: number;
    };
    data?: {
        [key: string]: any
    };
}

export const mapShipments = (shipments: ScheduledShipment[]): Map<number, ScheduledShipment> => {
    const shipmentMap = new Map<number, ScheduledShipment>();

    shipments.forEach((shipment) => {
        shipmentMap.set(shipment.product.id, shipment);
    });
    return shipmentMap;
};

export const mapForDateShipments = (shipments: ScheduledShipment[]): Map<string, ScheduledShipment[]> => {
    const shipmentMap = new Map<string, ScheduledShipment[]>();
    const today = new Date();
    const oneYearLater = addDays(today, 365);

    shipments.forEach((shipment) => {
        let currentDate = new Date(shipment.nextStartDate);
        while (currentDate <= oneYearLater) {
            const dateKey = currentDate.toISOString().split("T")[0];
            if (!shipmentMap.has(dateKey)) {
                shipmentMap.set(dateKey, []);
            }
            shipmentMap.get(dateKey)!.push(shipment);
            if (!shipment.reorderPeriod) break;
            currentDate = addDays(currentDate, shipment.reorderPeriod);
        }
    });
    return shipmentMap;
};
const getStartMonthOffset = (date: Date): number => {
    // return date.getDate() <= 15 ? 1 : 2;
    return 1;
};

export const getNextStartDates = (): Date[] => {
    const today = new Date();
    const startMonthOffset = getStartMonthOffset(today);
    return Array.from({length: 12}, (_, i) =>
        startOfMonth(addMonths(today, startMonthOffset + i))
    );
};

export const getNextStartWeeklyDates = (): Date[] => {
    const today = new Date();

    return optionReorderWeeklyValues
        .filter(o => o.value > 0)            // исключаем "no selected"
        .map(o => addDays(today, o.value as number));  // сегодняшняя + value дней
};

export const getNextStartDate = (): Date => {
    const today = new Date();
    const startMonthOffset = getStartMonthOffset(today);
    return startOfMonth(addMonths(today, startMonthOffset));
};

export const getByProductAndDealership = (product: Product, dealershipId: number): ScheduledShipmentSimple | undefined => {
    return product.shipments.find((item) => item.dealershipId === dealershipId);
};